module.exports = __webpack_public_path__ + "img/pic_guanli@2x.02e27287.png";